import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import TopBar from "../../topbar/TopBar.js";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/svg/nav-prev.svg";
import { ReactComponent as TickIcon } from "../../../assets/svg/tick.svg";
import { ReactComponent as CrossIcon } from "../../../assets/svg/close.svg";
import "./vehicle-create.css";
import { createGateApi, getEmployeeListApi } from "../../modal-dialog/setup-api.js";

import SearchWithAPI from "../../common/searchbox/searchbox.js";
import AsyncSelect from "react-select/async";
import { createVehicleApi, getTransporterListApi, getVendorListApi } from "../vehicle-api.js";
import moment from "moment";
import { ReactComponent as CameraProofIcon } from "../../../assets/svg/camera1.svg";
import { ReactComponent as CameraIcon } from "../../../assets/svg/camera.svg";
import { ReactComponent as UploadIcon } from "../../../assets/svg/upload_btn.svg";
import { ReactComponent as UploadImg } from "../../../assets/svg/upload_img.svg";
import { ReactComponent as ItemImg } from "../../../assets/svg/item_img.svg";
import { ReactComponent as GuestImg } from "../../../assets/svg/guests.svg";
import { ReactComponent as AddItem } from "../../../assets/svg/add_item.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/svg/call.svg";
import { ReactComponent as ClockIcon } from "../../../assets/svg/clock 2.svg";
import SearchWithFreeTextAPI from "../../common/searchbox/searchbox-free-text.js";
import camera from "../../../assets/svg/camera.svg";
import { ReactComponent as SlotCloseIcon } from "../../../assets/svg/close-1.svg";
import { ReactComponent as ItemNameIcon } from "../../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import ProfileImage from "../../../assets/png/customer-icon.png";
import { Toast, ToastContainer } from "react-bootstrap";
import AddItemModal from "../../modal-dialog/add-item-modal.js";
import AddGuestModal from "../../visitor/visitor-create/add-guest-modal.js";
import CheckListFailedModal from "../../modal-dialog/checklist-failed-modal.js";
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal.js";
import { gateInfoApi, getCheckList, getEnabledFieldApi, getLocation, getResponsiblePersonApi, sendOTPApi, verifyOTPApi, getMobileNumberBasedVisitor, getGateListApi, getVehicleBasedVisitor, getEVehicleInfoApi, getEDriverInfoApi } from "../../visitor/visitor-api.js";
import DOMPurify from "dompurify";
import { FaTimesCircle, FaCheck, FaTimes } from "react-icons/fa";
import AddMaster from "../../../assets/svg/add-master.svg";
import TransporterCreateModal from "../../modal-dialog/transporter-create-modal.js";
import VendorCreateModal from "../../modal-dialog/vendor-create-modal.js";
import PoweredBy from "../../common/poweredBy.jsx";
import ownerIcon from "../../../assets/svg/owner.svg";
import locationIcon from "../../../assets/svg/vehicle-location.svg";
import { validateExpiryStatus, checkIfExpired } from "../expiryDateValidation";
import permitIcon from "../../../assets/svg/permit_type.svg";
import vehicleModelIcon from "../../../assets/svg/vehicle.svg";
import vehicleTypeIcon from "../../../assets/svg/vehicle_type.svg";
import ManualVehicleModal from "./manual-vehicle-modal.jsx";
import ManualDriverModal from "./manual-driver-modal.jsx";

export const VehicleCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorId } = location.state || {};

  const [assignToOptions, setAssignToOptions] = useState([]);
  const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);

  const [enabledFields, setEnabledFields] = useState([]);

  const [selectedVendorLabels, setSelectedVendorLabels] = useState([]);
  const [selectedTransportLabels, setSelectedTransportLabels] = useState([]);
  const [showManualVehicleModal, setShowManualVehicleModal] = useState(false);
  const [showManualDriverModal, setShowManualDriverModal] = useState(false);

  //Vendor API

  const [selectedVendor, setSelectedVendor] = useState([]);

  const fetchVendors = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching vendor options with term:", inputValue);

      try {
        const response = await getVendorListApi(inputValue);
        if (response.status === 200 && response.data.success) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      } catch (error) {
        console.error("Error fetching vendor options:", error);
        callback([]); // In case of error, return an empty array
      }
    }, 1000); // Add delay for debouncing
  };

  const handleVendorChange = (selectedOptions) => {
    setSelectedVendorLabels(selectedOptions.map((option) => option.value));
    console.log(selectedOptions); // Log selected options
    setSelectedVendor(selectedOptions); // Store the selected vendor(s) in the state
  };

  //Transport API

  const [selectedTransport, setSelectedTransport] = useState([]);

  const fetchTransport = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getTransporterListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleTransportChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedTransport(selectedOptions);
    setSelectedTransportLabels(selectedOptions.map((option) => option.value));
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "f8f9fb",
        color: "#212129",
      },
    }),
  };

  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [gateOption, setGateOption] = useState(null);
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [loginPerson, setLoginPerson] = useState({});
  const [isProofMandatory, setIsProofMandatory] = useState(false);
  const [isChecklistMandatory, setIsChecklistMandatory] = useState(false);
  const [isOtpMandatory, setIsOtpMandatory] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOTP] = useState("");
  const [otpRef, setOTPRef] = useState("");
  const [isOTPSend, setIsOTPSend] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [visitorName, setVisitorName] = useState("");
  const [meetingType, setMeetingType] = useState("Direct");
  const [handleType, setHandleType] = useState("Dock handling");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [organizationOption, setOrganizationOption] = useState(null);
  const [purposeVisitOption, setPurposeVisitOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [email, setEmail] = useState("");
  const [checkList, setCheckList] = useState([]);
  const [transport, setTransport] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [errorCheckList, setErrorCheckList] = useState([]);

  // Vehicle Document Info States
  const [rcNumber, setRcNumber] = useState("TR54345352");
  const [rcExpiry, setRcExpiry] = useState("23 May 2028");
  const [rcStatus, setRcStatus] = useState("Active");
  const [insuranceCompany, setInsuranceCompany] = useState("ABC Private Limited");
  const [insuranceExpiry, setInsuranceExpiry] = useState("23 May 2028");
  const [insuranceStatus, setInsuranceStatus] = useState("Valid");
  const [permitNumber, setPermitNumber] = useState("PN46465");
  const [permitExpiry, setPermitExpiry] = useState("23 May 2028");
  const [permitType, setPermitType] = useState("Sample type");
  const [isGuestEnable, setIsGuestEnable] = useState(false);
  const [departmentOption, setDepartmentOption] = useState(null);
  const [meetingPersonOption, setMeetingPersonOption] = useState(null);
  const [meetingPerson, setMeetingPerson] = useState("");
  const [proofType, setProofType] = useState("");
  const [proofNumber, setProofNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  // Driver Info States
  const [driverIssueDate, setDriverIssueDate] = useState("23/05/2025");
  const [driverExpiryDate, setDriverExpiryDate] = useState("23/05/2025");
  const [driverStatus, setDriverStatus] = useState("Active");
  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [selectedTab, setSelectedTab] = useState("Items");
  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [guestList, setGuestList] = useState([]);
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [isValidateCheckList, setValidateCheckList] = useState(true);

  const [checkListStatus, setCheckListStatus] = useState("pending");
  const [scheduleDateTime, setScheduleDateTime] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [showAddItemModal, setAddItemModal] = useState(false);
  const [showAddGuestModal, setAddGuestModal] = useState(false);
  const [showChecklistFailedModal, setChecklistFailedModal] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [showTransportModal, setShowTransportModal] = useState(false);
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [eVehicleInfo, setEVehicleInfo] = useState(null);
  const [eDriverInfo, setEDriverInfo] = useState(null);
  const [isGetVehicleInfo, setIsGetVehicleInfo] = useState(false);
  const [isGetVehicleDataLoading, setIsGetVehicleDataLoading] = useState(false);
  const [isGetDriverInfo, setIsGetDriverInfo] = useState(false);
  const [isVehicleApiUnavailable, setIsVehicleApiUnavailable] = useState(false);
  const [isDriverApiUnavailable, setIsDriverApiUnavailable] = useState(false);
  const [validations, setValidations] = useState({
    gate_id: "",
    driver_name: "",
    in_time: "",
    organization: "",
    mobile_number: "",
    country_code: "",
    otp_verification_status: "",
    location_id: "",
    department_id: "",
    meeting_person: "",
    purpose_of_visit: "",
    proof_name: "",
    email: "",
    proof_value: "",
    items: "",
    uploads: "",
    profilephoto: "",
    checklists: "",
    validate_check_list: "",
    check_list_status: "",
    guests: "",
    dob: "",
  });

  const getRCStatusStyles = (status) => {
    const s = status?.toLowerCase();
    if (s === "active" || s === "na") {
      return { color: "#2C8C53", bgColor: "#E8F5E9" };
    }
    return { color: "#FF4444", bgColor: "#FFE5E5" };
  };

  useEffect(() => {
    getGateList();
    getEnabledField();
  }, []);
  useEffect(() => {
    if (gateOption != null || departmentOption != null) {
      getEnabledField();
    }
  }, [gateOption, departmentOption]);

  useEffect(() => {
    setEVehicleInfo(null);
    setIsVehicleApiUnavailable(false);
    setValidations((prev) => ({
      ...prev,
      vehicle_number: "",
      rc_msg: "",
      insurance_msg: "",
      permit_msg: "",
    }));
  }, [vehicleNumber]);

  useEffect(() => {
    setEDriverInfo(null);
    setIsDriverApiUnavailable(false);
    setValidations((prev) => ({
      ...prev,
      dlnumber: "",
      license_msg: "",
    }));
  }, [proofNumber]);
  const isFieldEnabled = (field) => {
    return enabledFields.some((item) => item === field);
  };
  const isFieldMandatory = (field) => {
    return mandatoryFields.some((item) => item === field);
  };
  const getGateList = async () => {
    try {
      const response = await getGateListApi();
      if (response.status === 200 && response.data.success === true) {
        if (response.data.suggestionlist.length > 0) {
          handleGateDropdownChange(response.data.suggestionlist[0]);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleGateDropdownChange = (option) => {
    console.log(option);
    setGateOption(option);
    getLocationData(option.value);
    getGateInfo(option.value);
    getResponsiblePerson(option.value);
  };
  const handleMobileNumberDropdownChange = (option) => {
    setMobileNumber(option.value);
    getMobileNumberBasedVisitorData(option.value);
    setIsOTPSend(false);
  };
  const handleMobileNumberOnChange = (term) => {
    setMobileNumber(term);
    setIsOTPSend(false);
  };

  const handlePurposeVisitDropdownChange = (option) => {
    console.log(option);
    setPurposeVisitOption(option);
  };
  const handleDepartmentDropdownChange = (option) => {
    console.log(option);
    setDepartmentOption(option);
  };
  const handleMeetingPersonDropdownChange = (option) => {
    console.log(option);
    setMeetingPersonOption(option);
  };

  const handleVehicleTypeDropdownChange = (option) => {
    console.log(option);
    setVehicleTypeOption(option);
  };

  const handleTransportDropdownChange = (option) => {
    console.log(option);
    setSelectedTransport(option);
  };

  const handleVendorDropdownChange = (option) => {
    console.log(option);
    setSelectedVendor(option);
  };

  const getMobileNumberBasedVisitorData = async (mobileNumber) => {
    try {
      const response = await getMobileNumberBasedVisitor(mobileNumber, "Vehicle");
      if (response.success === true && response.message !== "MobileNumber Not Available !!") {
        const visitorData = response.data;
        setGateOption({
          value: visitorData.gate_id ?? "",
          label: visitorData.gate ?? "Select",
        });
        setVisitorName(visitorData.driver_name ?? "");
        setEmail(visitorData.email ?? "");
        setProofNumber(visitorData.proof_value ?? "");
        setLocationOption({
          value: visitorData.location_id ?? "",
          label: visitorData.location ?? "Select",
        });
        setDepartmentOption({
          value: visitorData.department_id ?? "",
          label: visitorData.department ?? "Select",
        });
        setVehicleNumber(visitorData.vehicle_number);
        setVehicleTypeOption({
          value: visitorData.vehicletype_id ?? "",
          label: visitorData.vehicle_type ?? "Select",
        });
        getLocationData(visitorData.gate_id);
        setSelectedTransport(
          visitorData.transporters?.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          })),
        );
        setSelectedVendor(
          visitorData.vendors?.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          })),
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getVehicleNumberBasedVisitorData = async () => {
    setIsGetVehicleDataLoading(true);
    try {
      const response = await getVehicleBasedVisitor({
        vehicle_number: vehicleNumber,
      });
      if (response.success === true && response.message !== "Vehicle Number Not Available !!") {
        const visitorData = response.data;
        // setGateOption({
        //   value: visitorData.gate_id ?? "",
        //   label: visitorData.gate ?? "Select",
        // });
        setVisitorName(visitorData.driver_name ?? "");
        setEmail(visitorData.email ?? "");
        setProofNumber(visitorData.proof_value ?? "");
        setLocationOption({
          value: visitorData.location_id ?? "",
          label: visitorData.location ?? "Select",
        });
        setDepartmentOption({
          value: visitorData.department_id ?? "",
          label: visitorData.department ?? "Select",
        });
        setMobileNumber(visitorData.mobile_number);
        setVehicleTypeOption({
          value: visitorData.vehicletype_id ?? "",
          label: visitorData.vehicle_type ?? "Select",
        });
        getLocationData(visitorData.gate_id);
        setSelectedTransport(
          visitorData.transporters?.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          })),
        );
        setSelectedVendor(
          visitorData.vendors?.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          })),
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsGetVehicleDataLoading(false);
    }
  };

  const handleVehicleNumberChange = (event) => {
    const value = event.target.value.toUpperCase();
    setVehicleNumber(value);
  };

  const handleProofNumberChange = (event) => {
    let value = event.target.value;
    value = value.toUpperCase();
    setProofNumber(value);
  };

  const getLocationData = async (gateId) => {
    try {
      const response = await getLocation(gateId);
      if (response.status === true) {
        setLocationOption({
          value: response.details.location_id,
          label: response.details.location,
        });
        // setIsGuestEnable(response.details.guest_enabled);
        getCheckListData(response.details.location_id);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEnabledField = async () => {
    const data = {
      type: "Vehicle",
      gate_id: gateOption != null ? gateOption.value : "",
      department_id: departmentOption != null ? departmentOption.value : "",
    };
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {});
        setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getGateInfo = async (gateId) => {
    const data = { gate_id: gateId };
    try {
      const response = await gateInfoApi(data);
      if (response.success === true) {
        setIsProofMandatory(response?.gate_details?.proof_mandatory ?? false);
        setIsChecklistMandatory(response?.gate_details?.checklist_mandatory ?? false);
        setIsOtpMandatory(response?.gate_details?.otp_mandatory ?? false);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getResponsiblePerson = async (gateId) => {
    try {
      const response = await getResponsiblePersonApi(gateId);
      if (response.success === true) {
        setResponsiblePerson(response.responsible_person);
        setLoginPerson(response?.employee ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCheckListData = async (locationId) => {
    try {
      const response = await getCheckList(locationId, "Vehicle");
      if (response.success === true) {
        setCheckList(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };  const sendOTPData = async (mobilenumber) => {
    setIsOTPSend(true);
    setLoadingOTP(true);
    setOTPRef("");
    setIsOTPVerified(false);
    setOTP("");
    setValidations((prev) => ({
      ...prev,
      otp_verification_status: "",
    }));
    try {
      const response = await sendOTPApi({
        template_name: "Gate-Visitor-OTP",
        mobilenumber: mobilenumber,
      });
      if (response.success === true) {
        setOTPRef(response.otp_id);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoadingOTP(false);
    }
  };

  const verifyOTP = async () => {
    setIsOTPVerified(false);
    const data = {
      location_id: locationOption.value,
      otp_id: otpRef,
      received_otp: otp,
    };
    try {
      const response = await verifyOTPApi(data);
      if (response && (response.success === true || response.status === true)) {
        setIsOTPVerified(true);
        setSnackbarMessage(response.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        setValidations(prev => ({
          ...prev,
          otp_verification_status: ""
        }));
      } else {
        setIsOTPVerified(false);
        setValidations(prev => ({
          ...prev,
          otp_verification_status: response?.message || "Invalid OTP!"
        }));
      }
      return response?.data;
    } catch (err) {
      console.error("Error fetching category:", err);
      setIsOTPVerified(false);
      setValidations(prev => ({
        ...prev,
        otp_verification_status: "Invalid OTP!"
      }));
    } finally {
    }
  };


  // Helper function to validate insurance status based on insurance_upto date
  /*   const validateExpiryStatus = (insuranceUptoDate) => {
    if (!insuranceUptoDate || insuranceUptoDate === "N/A") {
      return { status: "Unknown", color: "#8790A1", bgColor: "#F5F5F5" };
    }

    try {
      // Parse date format like "13-Jun-2026"
      const parsedDate = moment(insuranceUptoDate, "DD-MMM-YYYY");

      if (!parsedDate.isValid()) {
        return { status: "Invalid Date", color: "#FF4444", bgColor: "#FFE5E5" };
      }

      const today = moment();
      const daysUntilExpiry = parsedDate.diff(today, "days");

      if (daysUntilExpiry < 0) {
        return { status: "Expired", color: "#FF4444", bgColor: "#FFE5E5" };
      } else if (daysUntilExpiry <= 30) {
        return {
          status: "Expiring Soon",
          color: "#FF8C00",
          bgColor: "#FFF4E5",
        };
      } else {
        return { status: "Active", color: "#2C8C53", bgColor: "#E8F5E9" };
      }
    } catch (error) {
      console.error("Error parsing insurance date:", error);
      return { status: "Error", color: "#FF4444", bgColor: "#FFE5E5" };
    }
  }; */

  const getEVehicleInfo = async (vehicleNo) => {
    setEVehicleInfo(null);
    setValidations((prev) => ({ ...prev, vehicle_number: "", rc_msg: "", insurance_msg: "", permit_msg: "" }));
    setIsGetVehicleInfo(true);
    setIsVehicleApiUnavailable(false);
    try {
      const payload = {
        vehicle_number: vehicleNo,
      };
      const response = await getEVehicleInfoApi(payload);
      if (response.success === true) {
        setEVehicleInfo(response.vehicle_data);
        setIsVehicleApiUnavailable(false);
        setValidations((prev) => ({ ...prev, vehicle_number: "", rc_msg: "", insurance_msg: "", permit_msg: "" }));
      } else {
        if (response.success === false) {
          setEVehicleInfo(response.vehicle_data);
          setIsVehicleApiUnavailable(response.api_unavailable ?? false);
          setValidations((prev) => {
            const validationTemp = { ...prev };
            let errorMsg = response.message;
            if (response.error) {
              if (Array.isArray(response.error) && response.error.length > 0) {
                errorMsg = response.error[0];
              } else if (typeof response.error === "object") {
                Object.entries(response.error).forEach(([key, value]) => {
                  validationTemp[key] = Array.isArray(value) ? value[0] : value;
                });
                if (response.error.vehicle_number) {
                  errorMsg = Array.isArray(response.error.vehicle_number) ? response.error.vehicle_number[0] : response.error.vehicle_number;
                }
              } else if (typeof response.error === "string") {
                errorMsg = response.error;
              }
            }
            validationTemp["vehicle_number"] = errorMsg;
            return validationTemp;
          });
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsGetVehicleInfo(false);
    }
  };

  const getEDriverInfo = async () => {
    setEDriverInfo(null);
    setValidations((prev) => ({
      ...prev,
      dlnumber: "",
      dob: "",
      license_msg: "",
    }));
    setIsGetDriverInfo(true);
    setIsDriverApiUnavailable(false);
    try {
      const payload = {
        dlnumber: proofNumber,
        dob: dateOfBirth,
      };
      const response = await getEDriverInfoApi(payload);
      if (response.success === true) {
        setEDriverInfo(response.driver_data);
        setIsDriverApiUnavailable(false);
        setValidations((prev) => ({
          ...prev,
          dob: "",
          dlnumber: "",
          license_msg: "",
        }));
      } else {
        if (response.success === false) {
          setIsDriverApiUnavailable(response.api_unavailable ?? false);
          setValidations((prev) => {
            const validationTemp = { ...prev };
            let errorMsg = response.message;
            if (response.error) {
              if (Array.isArray(response.error) && response.error.length > 0) {
                errorMsg = response.error[0];
              } else if (typeof response.error === "object") {
                Object.entries(response.error).forEach(([key, value]) => {
                  validationTemp[key] = Array.isArray(value) ? value[0] : value;
                });
                if (response.error.dlnumber) {
                  errorMsg = Array.isArray(response.error.dlnumber) ? response.error.dlnumber[0] : response.error.dlnumber;
                }
              } else if (typeof response.error === "string") {
                errorMsg = response.error;
              }
            }
            validationTemp["dlnumber"] = errorMsg;
            return validationTemp;
          });
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsGetDriverInfo(false);
    }
  };

  const submitVehicle = async (isCheckListValidate, checkListStatus) => {
    try {
      let dataBeforeSanitize = {
        gate_id: gateOption != null ? gateOption.value : "",
        driver_name: visitorName,
        in_time: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        mobile_number: mobileNumber,
        country_code: countryCode === "" ? "91" : countryCode,
        otp_verification_status: isOTPVerified,
        email: email,
        vendors: selectedVendor?.filter((item) => item.value !== "").map((item) => item.value),
        transporters: selectedTransport?.filter((item) => item.value !== "").map((item) => item.value),
        vehicle_number: vehicleNumber,
        location_id: locationOption != null ? locationOption.value : "",
        department_id: departmentOption != null ? departmentOption.value : null,
        vehicletype_id: vehicleTypeOption != null ? vehicleTypeOption.value : "",
        license_number: proofNumber,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: parseInt(DOMPurify.sanitize(item.quantity) ?? "0"),
          description: DOMPurify.sanitize(item.description),
        })),
        license_attachment: base64FileLicenseList,
        attachments: base64FileList,
        checklists: checkList.map((check) => ({
          id: check.id,
          value: DOMPurify.sanitize(check.inputvalue?.toString()),
        })),
        validate_check_list: isCheckListValidate,
        check_list_status: checkListStatus,
        purpose: handleType,
        driver_dob: dateOfBirth,
        vehicle_maker_model: eVehicleInfo?.maker_model ?? null,
        body_type: eVehicleInfo?.body_type ?? null,
      };
      if (eVehicleInfo !== null) {
        dataBeforeSanitize = {
          ...dataBeforeSanitize,
          ...eVehicleInfo,
        };
      }
      if (eDriverInfo !== null) {
        dataBeforeSanitize = {
          ...dataBeforeSanitize,
          ...eDriverInfo,
        };
      }
      const dataAfterSanitize = {};
      const skipSanitize = ["items", "checklists", "license_attachment", "attachments", "driver_image", "vendors", "transporters", "driver_dob"];

      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || skipSanitize.includes(key)) {
          dataAfterSanitize[key] = value;
        } else if (value && typeof value === "string") {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        } else {
          dataAfterSanitize[key] = value;
        }
      });

      console.log("Submitting Vehicle Data:", dataAfterSanitize);
      const response = await createVehicleApi(dataAfterSanitize);

      if (response && response.status === 200) {
        if (response.data.status === true || response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(true);
          handleSnackbarShow();
          navigate(-1);
        } else {
          if (response.data.error) {
            const validationTemp = {
              gate_id: "",
              driver_name: "",
              in_time: "",
              mobile_number: "",
              country_code: "",
              otp_verification_status: "",
              email: "",
              vehicle_number: "",
              location_id: "",
              department_id: "",
              vehicletype_id: "",
              license_number: "",
              items: "",
              license_attachment: "",
              attachments: "",
              checklists: "",
              validate_check_list: "",
              check_list_status: "",
              dob: "",
              insurance_msg: "",
              rc_msg: "",
              permit_msg: "",
              license_msg: "",
            };
            Object.entries(response.data.error).forEach(([key, value]) => {
              const errorMsg = Array.isArray(value) && value.length > 0 ? value[0] : value;
              if (key === "insurance_upto") {
                validationTemp["insurance_msg"] = errorMsg;
              } else if (key === "permit_valid_upto") {
                validationTemp["permit_msg"] = errorMsg;
              } else if (key === "rc_valid_upto") {
                validationTemp["rc_msg"] = errorMsg;
              } else if (key === "valid_till") {
                validationTemp["license_msg"] = errorMsg;
              } else {
                validationTemp[key] = errorMsg;
              }
            });
            setValidations(validationTemp);
          } else {
            setSnackbarMessage(response.data.message || "Failed to create vehicle");
            setSnackbarStatus(false);
            handleSnackbarShow();
          }
        }
      } else if (response && response.status === 402) {
        setErrorCheckList(response.data.error);
      } else if (response && response.status === 400) {
        const validationTemp = {
          gate_id: "",
          driver_name: "",
          in_time: "",
          mobile_number: "",
          country_code: "",
          otp_verification_status: "",
          email: "",
          vehicle_number: "",
          location_id: "",
          department_id: "",
          vehicletype_id: "",
          license_number: "",
          items: "",
          license_attachment: "",
          attachments: "",
          checklists: "",
          validate_check_list: "",
          check_list_status: "",
          dob: "",
          insurance_msg: "",
          rc_msg: "",
          permit_msg: "",
          license_msg: "",
        };
        if (response.data.error) {
          Object.entries(response.data.error).forEach(([key, value]) => {
            const errorMsg = Array.isArray(value) && value.length > 0 ? value[0] : value;
            if (key === "insurance_upto") {
              validationTemp["insurance_msg"] = errorMsg;
            } else if (key === "permit_valid_upto") {
              validationTemp["permit_msg"] = errorMsg;
            } else if (key === "rc_valid_upto") {
              validationTemp["rc_msg"] = errorMsg;
            } else if (key === "valid_till") {
              validationTemp["license_msg"] = errorMsg;
            } else {
              validationTemp[key] = errorMsg;
            }
          });
        }
        setValidations(validationTemp);
      } else {
        setSnackbarMessage("Something went wrong. Please try again.");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Submit vehicle failed:", error);
      setSnackbarMessage("An unexpected error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsSubmitting(false);
    }
  };

  const [activeCameraTarget, setActiveCameraTarget] = useState("");
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  useEffect(() => {
    if (activeCameraTarget !== "") {
      setImage(null);
      getVideo();
    }
  }, [activeCameraTarget]);
  const getVideo = () => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      console.log("Devices start:", devices);
    });

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        streamRef.current = stream;
        console.log(videoRef.current);
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
      });
  };
  const stopVideo = () => {
    console.log(streamRef.current);

    if (streamRef.current) {
      console.log(streamRef.current.getTracks());
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    console.log(videoRef.current);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setActiveCameraTarget("");
    forceStopCamera();
  };
  const forceStopCamera = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();

    if (devices.some((device) => device.kind === "videoinput")) {
      const tempStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      tempStream.getTracks().forEach((track) => track.stop()); // Force stop

      console.log("Force-stopped extra video streams.");
    }
  };
  const captureImage = (setImageList, imageList, setBase64List, base64List) => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Set canvas size to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame on the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to image URL
    const imageUrl = canvas.toDataURL("image/png");

    const tempImages = [...imageList];
    tempImages.push(imageUrl);
    setImageList(tempImages);

    const tempBase64 = [...base64List];
    tempBase64.push(imageUrl);
    setBase64List(tempBase64);

    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setActiveCameraTarget("");
  };

  const renderProofCard = ({ targetKey, title, mandatoryField, onUploadClick, imageList, setImageList, base64List, setBase64List }) => {
    const isCameraActive = activeCameraTarget === targetKey;
    return (
      <div className="proof-card-view">
        {isCameraActive && (
          <div style={{ position: "relative", marginBottom: "8px" }}>
            <video ref={videoRef} autoPlay playsInline style={{ width: "100%", borderRadius: "7px", objectFit: "cover" }} />
            <div
              onClick={() => {
                stopVideo();
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
            >
              <CrossIcon />
            </div>
            <div
              onClick={() => {
                captureImage(setImageList, imageList, setBase64List, base64List);
                stopVideo();
                setActiveCameraTarget("");
              }}
              style={{
                position: "absolute",
                bottom: "10px",
                left: "45%",
                cursor: "pointer",
              }}
            >
              <img src={camera} style={{ width: "30px", height: "30px", margin: "0" }} alt="capture" />
            </div>
            <canvas ref={canvasRef} style={{ display: "none" }} />
          </div>
        )}
        {!isCameraActive && (
          <>
            <div>
              <UploadImg />
            </div>
            <div className="proof-photo-title mt-2">
              {title}
              {isFieldMandatory(mandatoryField) && <span style={{ color: "#FF4444" }}>*</span>}
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
              <div
                className="proof-btn style-justify-center"
                onClick={() => {
                  setActiveCameraTarget(targetKey);
                }}
              >
                <CameraIcon />
                <div className="proof-btn-txt">Camera</div>
              </div>
              <div className="proof-btn style-justify-center" onClick={onUploadClick}>
                <UploadIcon />
                <div className="proof-btn-txt">Upload</div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  const [selectedLicenseImageList, setSelectedLicenseImageList] = useState([]);
  const [base64FileLicenseList, setBase64FileLicenseList] = useState([]);
  const [selectedImageList, setSelectedImageList] = useState([]);
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);
  const [removedImageList, setRemovedImageList] = useState([]);

  const licenseFileInputRef = useRef(null);
  const handleLicenseFileClick = () => {
    if (licenseFileInputRef.current) {
      licenseFileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleLicenseFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64LicenseFileList = [...base64FileLicenseList];
        tempBase64LicenseFileList.push(base64String);
        setBase64FileLicenseList(tempBase64LicenseFileList);
      };
      reader.readAsDataURL(file);
      const tempImageList = [...selectedLicenseImageList];
      tempImageList.push(URL.createObjectURL(file));
      setSelectedLicenseImageList(tempImageList);
    } else {
      alert("Please select a valid image file.");
    }
    event.target.value = "";
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList);
      };
      reader.readAsDataURL(file);
      const tempImageList = [...selectedImageList];
      tempImageList.push(URL.createObjectURL(file));
      setSelectedImageList(tempImageList);
    } else {
      alert("Please select a valid image file.");
    }
    event.target.value = "";
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item);
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem);
  };

  const onSaveGuest = (itemData) => {
    setAddGuestModal(false);
    const tempGuest = [...guestList];
    if (itemData.index === null) {
      tempGuest.push(itemData.guest);
    } else {
      tempGuest[itemData.index] = itemData.guest;
    }
    setGuestList(tempGuest);
  };

  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null);
    }
  };
  const onProceedCheckList = () => {
    setChecklistFailedModal(false);
    setChecklistFailedAdminModal(false);
    setValidateCheckList(false);
    submitVehicle(false, "pending");
  };
  const onApprovedCheckList = () => {
    setValidateCheckList(false);
    setChecklistFailedAdminModal(false);
    setCheckListStatus("approve");
    submitVehicle(false, "approve");
  };
  useEffect(() => {
    if (errorCheckList.length > 0) {
      if (responsiblePerson === loginPerson.id) {
        setChecklistFailedAdminModal(true);
      } else {
        setChecklistFailedModal(true);
      }
    }
  }, [errorCheckList]);

  const onSuccessVendor = async (response) => {
    setShowVendorModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
  };

  const onSuccessTransport = async (response) => {
    setShowTransportModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
  };

  return (
    <Container fluid className="main-container">
      {showAddItemModal && (
        <AddItemModal
          moduleName={"Vehicle"}
          itemData={itemData}
          onSave={onSaveItem}
          onCancel={() => {
            setAddItemModal(false);
            setItemData(null);
          }}
        />
      )}
      {showAddGuestModal && (
        <AddGuestModal
          enabledFields={enabledFields}
          mandatoryFields={mandatoryFields}
          itemData={itemData}
          onSave={onSaveGuest}
          onCancel={() => {
            setAddGuestModal(false);
            setItemData(null);
          }}
        />
      )}
      {showChecklistFailedModal && (
        <CheckListFailedModal
          checkList={errorCheckList}
          loginPerson={loginPerson}
          onSave={onProceedCheckList}
          onCancel={() => {
            setChecklistFailedModal(false);
          }}
        />
      )}
      {showChecklistFailedAdminModal && (
        <CheckListFailedAdminModal
          checkList={errorCheckList}
          visitorName={visitorName}
          organization={organizationOption != null && organizationOption.value}
          visitorPicture={image ?? ""}
          isSaveEnable={true}
          onSave={onProceedCheckList}
          isApprovedEnable={true}
          onApproved={onApprovedCheckList}
          onCancel={() => {
            setChecklistFailedAdminModal(false);
          }}
        />
      )}
      {showTransportModal && <TransporterCreateModal povId={null} onSuccess={onSuccessTransport} onCancel={() => setShowTransportModal(false)} />}
      {showVendorModal && <VendorCreateModal povId={null} onSuccess={onSuccessVendor} onCancel={() => setShowVendorModal(false)} />}
      {showManualVehicleModal && (
        <ManualVehicleModal
          vehicleNo={vehicleNumber}
          onCancel={() => setShowManualVehicleModal(false)}
          onSubmit={(data) => {
            console.log("Manual Vehicle Data:", data);
            setShowManualVehicleModal(false); // Optionally update state with the manual data
            setRcNumber(data.rcData.number);
            setRcExpiry(data.rcData.expiryDate);
            setRcStatus(data.rcData.status);
          }}
        />
      )}
       {" "}
      {showManualDriverModal && (
        <ManualDriverModal
          licenseNo={proofNumber}
          onCancel={() => setShowManualDriverModal(false)}
          onSubmit={(data) => {
            console.log("Manual Driver Data:", data);
            setShowManualDriverModal(false);
            setDriverExpiryDate(data.expiryDate);
            setDriverStatus(data.status);
          }}
        />
      )}
      <div style={{ width: "100vw" }}>
        <TopBar currentName="vehicle" />

        <Row sm={12} className="main-row">
          <Col className="mx-2 " sm={12} style={{ padding: "16px" }}>
            <Row sm={12}>
              <Col sm={6} md={9}>
                <div className="style-justify-start">
                  <div
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BackIcon />
                  </div>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#21272C",
                    }}
                  >
                    Add vehicle
                  </span>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="style-justify-end" style={{ gap: "8px" }}>
                  <div
                    className="cancel_btn"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#21272C",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    className="success_btn"
                    style={{
                      width: "100px", // 👈 set fixed width
                      height: "40px", // 👈 optional but recommended
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: isSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (isSubmitting) return;
                      setIsSubmitting(true);
                      submitVehicle(true, "pending");
                    }}
                  >
                    {isSubmitting ? (
                      <span className="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#FFFFFF",
                        }}
                      >
                        Submit
                      </span>
                    )}
                  </div>
                  {/* <div
                    className="success_btn"
                    onClick={() => {
                      submitVehicle(true, "pending");
                  
                    }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#FFFFFF",
                      }}
                    >
                      Submit
                    </div>
                  </div> */}
                </div>
              </Col>
            </Row>
            <Row className="mt-3 ">
              <Col xs={12} sm={12} lg={6}>
                <div className="card-view">
                  <div className="style-justify-start">
                    <div className="gate-title" style={{ width: "120px" }}>
                      Entry gate<span style={{ color: "#FF4444" }}>*</span> :{" "}
                    </div>
                    <div className="w-100">
                      <SearchWithAPI onDropdownChange={handleGateDropdownChange} apiUrl={apiUrl + "gate/autosuggestion"} params={{}} placeholder={"Gate"} selectedOption={gateOption} />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.gate_id}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-view mt-3">
                  <div className="card-title">Verify visitor mobile number</div>
                  <Row style={{ display: "flex" }}>
                    {/* {isFieldEnabled("Mobile number") && ( */}
                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">
                        Mobile number
                        {isFieldMandatory("Mobile number") && <span style={{ color: "#FF4444" }}>*</span>}
                      </div>
                      <div className="style-justify-start-start mt-1" style={{ gap: "8px" }}>
                        <div style={{ width: "68%" }}>
                          <SearchWithFreeTextAPI numberOnly={true} readOnly={isOTPVerified === true ? true : false} onDropdownChange={handleMobileNumberDropdownChange} onChangeSearch={handleMobileNumberOnChange} apiUrl={apiUrl + `mobile_autocomplete`} params={{ type: "Vehicle" }} searchLimit={6} placeholder={"Select"} selectedValue={mobileNumber} />
                        </div>
                        {meetingType === "Direct" && (
                          <div
                            className="success_btn "
                            style={{
                              width: "30%",
                              cursor: (!loadingOTP && mobileNumber && mobileNumber.trim().length >= 10) ? "pointer" : "not-allowed",
                              opacity: (!loadingOTP && mobileNumber && mobileNumber.trim().length >= 10) ? 1 : 0.6
                            }}
                            onClick={() => {
                              if (!loadingOTP && mobileNumber && mobileNumber.trim().length >= 10) {
                                sendOTPData(mobileNumber);
                              }
                            }}
                          >
                            <div
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#FFFFFF",
                              }}
                            >
                              {!isOTPSend ? "Send OTP" : "Resend"}
                            </div>
                          </div>
                        )}
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.mobile_number}
                      </span>
                    </Col>
                    {/* {isFieldEnabled("Mobile number") && ( */}
                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">OTP verification {isOtpMandatory && <span style={{ color: "#FF4444" }}>*</span>}</div>
                      <div className="mt-1" style={{ position: "relative" }}>
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here "
                            readOnly={isOTPVerified === true ? true : false}
                            className="input-field w-100"
                            value={otp}
                            onChange={(event) => {
                              const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                              setOTP(value);
                              setValidations((prev) => ({
                                ...prev,
                                otp_verification_status: "",
                              }));
                            }}
                          />
                        </div>
                        {isOTPVerified === false && (
                          <button
                            className="btn btn-primary verify-btn"
                            type="button"
                            style={{ opacity: otpRef !== "" ? 1 : 0.6 }}
                            onClick={() => {
                              otpRef !== "" && verifyOTP();
                            }}
                          >
                            Verify
                          </button>
                        )}
                      </div>
                      {isOTPVerified === true && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#2C8C53",
                          }}
                        >
                          Verified
                        </span>
                      )}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.otp_verification_status}
                      </span>
                    </Col>

                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">
                        Driver Name<span style={{ color: "#FF4444" }}>*</span>
                      </div>
                      <div className="mt-1">
                        <div>
                          <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={visitorName}
                            onChange={(event) => {
                              setVisitorName(event.target.value);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.driver_name}
                        </span>
                      </div>
                    </Col>
                    {/* {isFieldEnabled("Department") && ( */}
                    <Col sm={12} lg={6} className="mt-3">
                      <div className="field-title">
                        Department
                        {isFieldMandatory("Department") && <span style={{ color: "#FF4444" }}>*</span>}
                      </div>
                      <div className="mt-1">
                        <div>
                          <SearchWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.department_id}
                          </span>
                        </div>
                      </div>
                    </Col>
                    {/* )} */}
                    {isFieldEnabled("Location") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Location
                          {isFieldMandatory("Location") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <input type="text" placeholder="" className="input-field w-100" value={locationOption?.label ?? ""} readOnly="true" />
                          </div>
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.location_id}
                        </span>
                      </Col>
                    )}

                    {isFieldEnabled("Vehicle type") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Vehicle type
                          {isFieldMandatory("Vehicle type") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <SearchWithAPI onDropdownChange={handleVehicleTypeDropdownChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={vehicleTypeOption} />
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.vehicletype_id}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}

                    {isFieldEnabled("Vehicle number") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Vehicle Number
                          {isFieldMandatory("Vehicle number") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div style={{ position: "relative", width: "100%" }}>
                              <input type="text" placeholder="Enter here" className="input-field" value={vehicleNumber} onChange={handleVehicleNumberChange} style={{ width: "100%" }} />
                            </div>
                            <button
                              onClick={() => {
                                if (isFieldEnabled("RC info") || isFieldEnabled("Insurance info") || isFieldEnabled("Permit info")) {
                                  getEVehicleInfo(vehicleNumber);
                                }
                                getVehicleNumberBasedVisitorData(vehicleNumber);
                              }}
                              disabled={isGetVehicleInfo || isGetVehicleDataLoading}
                              style={{
                                background: isGetVehicleInfo || isGetVehicleDataLoading ? "#7E8AFF" : "#3B5BDB",
                                color: "#FFFFFF",
                                border: "none",
                                borderRadius: "10px",
                                padding: "4px 11px",
                                fontSize: "13px",
                                fontWeight: "700",
                                cursor: isGetVehicleInfo || isGetVehicleDataLoading ? "not-allowed" : "pointer",
                                minWidth: "75px",
                                height: "32px",
                              }}
                            >
                              {isGetVehicleInfo || isGetVehicleDataLoading ? <Spinner animation="border" size="sm" style={{ color: "#ffffff" }} /> : "Get Info"}
                            </button>
                          </div>
                          {validations.vehicle_number && (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "13px",
                                fontWeight: 500,
                                color: "#FF4444",
                                marginTop: "8px",
                                gap: "6px",
                                whiteSpace: "nowrap",
                                flexWrap: "nowrap",
                                position: "relative",
                                zIndex: 999,
                                pointerEvents: "auto",
                              }}
                            >
                              <FaTimesCircle />
                              <span>{validations.vehicle_number}</span>
                              {isVehicleApiUnavailable && (
                                <span
                                  style={{
                                    color: "#2b59ff",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    marginLeft: "4px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setShowManualVehicleModal(true)}
                                >
                                  Add manually
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                      </Col>
                    )}

                    {isFieldEnabled("Email") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Email
                          {isFieldMandatory("Email") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <input
                              type="email"
                              placeholder="Enter here"
                              className="input-field w-100"
                              value={email}
                              onChange={(event) => {
                                setEmail(event.target.value);
                              }}
                            />
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.email}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}

                    {/* Vehicle Info Card */}
                    {(isFieldEnabled("RC info") || isFieldEnabled("Insurance info") || isFieldEnabled("Permit info")) && eVehicleInfo !== null && (
                      <Col sm={12} className="mt-3">
                        <div className="vehicle-info-main-card">
                          <div className="vehicle-info-header-text">VEHICLE INFO</div>

                          <div className="vehicle-main-info">
                            <div className="vehicle-header-row">
                              <div className="vehicle-number-section">
                                <div className="vehicle-number-large">{eVehicleInfo?.rc_number ?? "-"}</div>
                                <div className="vehicle-type-fuel-row">
                                  <span className="vehicle-type-text1" style={{ color: "#3253EB" }}>
                                    {eVehicleInfo?.maker_model ?? "-"}
                                  </span>
                                  <span className="vehicle-type-separator">•</span>
                                  <span className="vehicle-type-text1" style={{ color: "#2C8C53" }}>
                                    {eVehicleInfo?.body_type ?? "-"}
                                  </span>
                                  <span className="vehicle-type-separator">•</span>
                                  <span className="fuel-badge">{eVehicleInfo?.fuel_type ?? "-"}</span>
                                </div>
                              </div>
                              {isFieldEnabled("Permit info") && (
                                <div className="permit-info-section">
                                  <div className="permit-label">
                                    Permit : <span className="permit-number">{eVehicleInfo?.permit_number ?? "-"}</span>
                                  </div>

                                  <div className="permit-expiry" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
                                    <div>
                                      Expiry :{" "}
                                      <span
                                        className="permit-number"
                                        style={{
                                          color: validateExpiryStatus(eVehicleInfo?.permit_valid_upto).color,
                                        }}
                                      >
                                        {eVehicleInfo?.permit_valid_upto ?? "-"}
                                      </span>
                                    </div>
                                  </div>
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {validations.permit_msg}
                                  </span>
                                </div>
                              )}
                            </div>

                            <div className="vehicle-details-row">
                              <div className="info-with-icon">
                                <img src={ownerIcon} alt="driver" />
                                <span className="info-value">{eVehicleInfo?.owner_name ?? "-"}</span>
                              </div>
                              <div className="info-with-icon">
                                <img src={locationIcon} alt="location" />
                                <span className="info-value">{eVehicleInfo?.location ?? "-"}</span>
                              </div>
                              {isFieldEnabled("Permit info") && (
                                <div className="info-with-icon">
                                  <img src={permitIcon} alt="permit" />
                                  <span className="info-value">{eVehicleInfo?.permit_type && eVehicleInfo?.permit_type !== "undefined" ? eVehicleInfo?.permit_type : "-"}</span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="docs-row mb-2">
                            {/* RC Card */}
                            {isFieldEnabled("RC info") && (
                              <div className="doc-info-card rc-card">
                                <div className="doc-header">RC INFO</div>
                                <div className="doc-number">{eVehicleInfo?.rc_number ?? "-"}</div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "8px",
                                  }}
                                >
                                  <div className="doc-expiry">
                                    Exp :{" "}
                                    <span
                                      style={{
                                        color: validateExpiryStatus(eVehicleInfo?.rc_valid_upto).color,
                                      }}
                                    >
                                      {eVehicleInfo?.rc_valid_upto ?? "-"}
                                    </span>
                                  </div>
                                  <div
                                    className="status-badge"
                                    style={{
                                      backgroundColor: validateExpiryStatus(eVehicleInfo?.rc_valid_upto).bgColor,
                                      color: validateExpiryStatus(eVehicleInfo?.rc_valid_upto).color,
                                    }}
                                  >
                                    <span
                                      className="dot"
                                      style={{
                                        backgroundColor: validateExpiryStatus(eVehicleInfo?.rc_valid_upto).color,
                                      }}
                                    ></span>
                                    {validateExpiryStatus(eVehicleInfo?.rc_valid_upto).status}
                                  </div>
                                </div>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#FF4444",
                                  }}
                                >
                                  {validations.rc_msg}
                                </span>
                              </div>
                            )}

                            {/* Insurance Card */}
                            {isFieldEnabled("Insurance info") && (
                              <div className="doc-info-card insurance-card">
                                <div className="doc-header">INSURANCE INFO</div>
                                <div className="doc-number" title={eVehicleInfo?.insurance_company ?? "N/A"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {eVehicleInfo?.insurance_company ?? "N/A"}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "8px",
                                  }}
                                >
                                  <div className="doc-expiry">
                                    Exp :{" "}
                                    <span
                                      style={{
                                        color: validateExpiryStatus(eVehicleInfo?.insurance_upto).color,
                                      }}
                                    >
                                      {eVehicleInfo?.insurance_upto ?? "N/A"}
                                    </span>
                                  </div>
                                  <div
                                    className="status-badge"
                                    style={{
                                      backgroundColor: validateExpiryStatus(eVehicleInfo?.insurance_upto).bgColor,
                                      color: validateExpiryStatus(eVehicleInfo?.insurance_upto).color,
                                    }}
                                  >
                                    <span
                                      className="dot"
                                      style={{
                                        backgroundColor: validateExpiryStatus(eVehicleInfo?.insurance_upto).color,
                                      }}
                                    ></span>
                                    {validateExpiryStatus(eVehicleInfo?.insurance_upto).status}
                                  </div>
                                </div>
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#FF4444",
                                  }}
                                >
                                  {validations.insurance_msg}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    )}

                    {isFieldEnabled("Transporter") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Transport
                          {isFieldMandatory("Transporter") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div className="style-justify-start">
                            <div style={{ flex: 1 }}>
                              <AsyncSelect isMulti cacheOptions value={selectedTransport} loadOptions={fetchTransport} onChange={handleTransportChange} defaultOptions placeholder="Search transports..." styles={multiselectCustomStyles} isClearable={false} />
                            </div>
                            <div
                              className="ps-1"
                              onClick={() => {
                                setShowTransportModal(true);
                              }}
                            >
                              <img src={AddMaster} alt="scan" srcSet="" />
                            </div>
                          </div>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.transporters}
                          </span>
                        </div>
                      </Col>
                    )}

                    {isFieldEnabled("Vendor") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Vendor
                          {isFieldMandatory("Vendor") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div className="style-justify-start">
                            <div style={{ flex: 1 }}>
                              <AsyncSelect isMulti cacheOptions value={selectedVendor} loadOptions={fetchVendors} onChange={handleVendorChange} defaultOptions placeholder="Search vendors..." styles={multiselectCustomStyles} isClearable={false} />
                            </div>
                            <div
                              className="ps-1"
                              onClick={() => {
                                setShowVendorModal(true);
                              }}
                            >
                              <img src={AddMaster} alt="scan" srcSet="" />
                            </div>
                          </div>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.vendors}
                          </span>
                        </div>
                      </Col>
                    )}
                    {isFieldEnabled("Purpose") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Purpose
                          {isFieldMandatory("Purpose") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <select
                              className="select3 w-100 input-field"
                              id="perpage"
                              value={handleType}
                              onChange={(event) => {
                                setHandleType(event.target.value);
                              }}
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                                lineHeight: "18.9px",
                                color: handleType === "" ? "#8790A1" : "#172B4D",
                                height: "40px",
                                borderRadius: "10px",
                                border: "0.7px solid #E5E5E5",
                                padding: "0 8px",
                                gap: "77px",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              <option value="Dock handling">Dock handling</option>
                              <option value="Others">Others</option>
                            </select>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.purpose}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>

                <div className="card-view mt-2">
                  <div className="card-title">Check list {isChecklistMandatory && <span style={{ color: "#FF4444" }}>*</span>}</div>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                    }}
                  >
                    {validations.check_list_status}
                  </span>
                  <div className="mt-3" style={{ gap: "8px" }}>
                    {checkList.map((check, index) => {
                      if (check.inputvalue == null) {
                        check["inputvalue"] = "";
                      }
                      const checklistError = validations[`checklists.${index}.value`];
                      const cleanError = checklistError
                        ? checklistError.replace(/the checklists\.\d+\.value field/i, `"${check.checkname}"`).replace(/the checklists\.\d+\.value/i, `"${check.checkname}"`)
                        : "";
                      return (
                        <div key={"checklist" + index} className="mb-2">
                          <div className="check-list style-justify-between">
                            <div>{check.checkname}</div>
                            {check.creteria !== "Boolean" && (
                              <div>
                                <input
                                  style={{ width: "100px" }}
                                  type="text"
                                  placeholder={check.checkname}
                                  className="input-field"
                                  value={check.inputvalue}
                                  onChange={(event) => {
                                    const value = event.target.value.replace(/\D/g, "");
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = value;
                                    setCheckList(tempChecklist);
                                    setValidations((prev) => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: "",
                                    }));
                                  }}
                                />
                              </div>
                            )}

                            {check.creteria === "Boolean" && (
                              <div className="style-justify-start" style={{ gap: "8px" }}>
                                <div
                                  className={`checklist-bool style-justify-start ${check.inputvalue ? "active-bool-btn" : ""}`}
                                  onClick={() => {
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = true;
                                    setCheckList(tempChecklist);
                                    setValidations((prev) => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: "",
                                    }));
                                  }}
                                >
                                  <FaCheck
                                    style={{
                                      color: check.inputvalue ? "white" : "#172B4D",
                                    }}
                                  />{" "}
                                  <div style={{ paddingLeft: "8px" }}> Yes</div>
                                </div>
                                <div
                                  className={`checklist-bool style-justify-start ${check.inputvalue === false ? "in-active-bool-btn" : ""}`}
                                  onClick={() => {
                                    const tempChecklist = [...checkList];
                                    tempChecklist[index]["inputvalue"] = false;
                                    setCheckList(tempChecklist);
                                    setValidations((prev) => ({
                                      ...prev,
                                      [`checklists.${index}.value`]: "",
                                    }));
                                  }}
                                >
                                  <FaTimes
                                    style={{
                                      color: check.inputvalue === false ? "white" : "#172B4D",
                                    }}
                                  />
                                  <div style={{ paddingLeft: "8px" }}> No</div>
                                </div>
                              </div>
                            )}
                          </div>
                          {cleanError && (
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "end", fontSize: "11px", fontWeight: 400, color: "#FF4444", marginTop: "2px" }}>
                              {cleanError}
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} lg={6}>
                <div className="card-view">
                  <div className="style-justify-between">
                    <div className="card-title">Visit details</div>
                    {meetingType === "Direct" && (
                      <div className="today-date-time style-justify-center">
                        <ClockIcon />
                        <div className="px-2">{moment(new Date()).format("DD MMM YYYY [at] hh:mm A")}</div>
                      </div>
                    )}
                  </div>

                  <Row style={{ display: "flex" }}>
                    {isFieldEnabled("Purpose of visit") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Purpose of visit
                          {isFieldMandatory("Purpose of visit") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <SearchWithAPI onDropdownChange={handlePurposeVisitDropdownChange} apiUrl={apiUrl + "visit/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={purposeVisitOption} />
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.purpose_of_visit}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}
                    {/* {isFieldEnabled("Department") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">Department{isFieldMandatory("Department") && <span style={{ color: "#FF4444" }}>*</span>}</div>
                        <div className="mt-1">
                          <div>
                            <SearchWithAPI onDropdownChange={handleDepartmentDropdownChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.department_id}</span>
                          </div>
                        </div>
                      </Col>
                    )} */}
                    {isFieldEnabled("Meeting person") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Meeting person
                          {isFieldMandatory("Meeting person") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <input
                              type="text"
                              placeholder="Enter here"
                              className="input-field w-100"
                              value={meetingPerson}
                              onChange={(event) => {
                                setMeetingPerson(event.target.value);
                              }}
                            />
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.meeting_person_name}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}

                    {isFieldEnabled("Meeting person") && (
                      <Col sm={12} lg={6} className="mt-3">
                        <div className="field-title">
                          Meeting person
                          {isFieldMandatory("Meeting person") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                        <div className="mt-1">
                          <div>
                            <SearchWithAPI onDropdownChange={handleMeetingPersonDropdownChange} apiUrl={apiUrl + "get_meeting_person"} params={{}} placeholder={"Select"} selectedOption={meetingPersonOption} />
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.meeting_person}
                            </span>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>

                {(isFieldEnabled("Proof") || isFieldEnabled("Proof attachment")) && (
                  <div className="card-view mt-3">
                    {isFieldEnabled("Proof") && <div className="card-title">Proof details</div>}

                    <Row style={{ display: "flex" }}>
                      {isFieldEnabled("Proof") && (
                        <Col sm={12} lg={6} className="mt-3">
                          <div className="field-title">
                            Driving license number
                            {isFieldMandatory("Proof") && <span style={{ color: "#FF4444" }}>*</span>}
                          </div>
                          <div className="mt-1">
                            <div>
                              <input style={{ width: "100%" }} type="text" placeholder="Enter here" className="input-field" value={proofNumber} onChange={handleProofNumberChange} />

                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.proof_value}
                              </span>

                              {validations.dlnumber && (
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#FF4444",
                                    marginTop: "8px",
                                    gap: "6px",
                                    whiteSpace: "nowrap",
                                    flexWrap: "nowrap",
                                  }}
                                >
                                  <FaTimesCircle />
                                  <span>{validations.dlnumber}</span>
                                  {isDriverApiUnavailable && (
                                    <span
                                      style={{
                                        color: "#2b59ff",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        marginLeft: "4px",
                                        pointerEvents: "auto",
                                        position: "relative",
                                        zIndex: 10,
                                      }}
                                      onClick={() => setShowManualDriverModal(true)}
                                    >
                                      Add manually
                                    </span>
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}

                      {/* Date of Birth Field */}
                      {isFieldEnabled("Proof") && (
                        <Col sm={12} lg={6} className="mt-3">
                          <div className="field-title">Date of Birth</div>
                          <div className="mt-1">
                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ position: "relative", flex: 1 }}>
                                <input
                                  type="date"
                                  placeholder="dd/mm/yyyy"
                                  className="input-field"
                                  value={dateOfBirth}
                                  onChange={(event) => {
                                    setDateOfBirth(event.target.value);
                                  }}
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </div>
                              {isFieldEnabled("License info") && (
                                <button
                                  onClick={() => {
                                    if (isFieldEnabled("License info")) {
                                      getEDriverInfo();
                                    }
                                  }}
                                  disabled={isGetDriverInfo}
                                  style={{
                                    background: isGetDriverInfo ? "#7E8AFF" : "#3B5BDB",
                                    color: "#FFFFFF",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "4px 11px",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    cursor: isGetDriverInfo ? "not-allowed" : "pointer",
                                    minWidth: "75px",
                                    height: "32px",
                                  }}
                                >
                                  {isGetDriverInfo ? <Spinner animation="border" size="sm" style={{ color: "#ffffff" }} /> : "Get Info"}
                                </button>
                              )}
                            </div>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.dob}
                            </span>
                          </div>
                        </Col>
                      )}

                      {/* Driver Info Card */}
                      {isFieldEnabled("License info") && eDriverInfo !== null && (
                        <Col sm={12} className="mt-3">
                          <div className="driver-info-card">
                            <div className="driver-info-header">DRIVER INFO</div>

                            <div className="driver-info-content">
                              <div className="driver-row">
                                <div className="driver-profile-section">
                                  <img src={eDriverInfo?.driver_image ?? ProfileImage} alt="Driver" className="driver-profile-image" />
                                </div>

                                <div className="driver-details-section ms-2">
                                  <div className="driver-name">{eDriverInfo?.name ?? "N/A"}</div>
                                  <div className="driver-dob">
                                    <span className="dob-label">DOB :</span>
                                    <span className="dob-value">{dateOfBirth ? new Date(dateOfBirth).toLocaleDateString("en-GB").replace(/\//g, "/") : ""}</span>
                                  </div>
                                </div>
                              </div>

                              <div className="driver-info-row mt-2">
                                <div className="driver-info-item">
                                  <span className="info-item-label">Issue date :</span>
                                  <span className="info-item-value">{eDriverInfo?.valid_from ?? "N/A"}</span>
                                </div>
                                <div className="driver-info-item">
                                  <span className="info-item-label">Expiry date :</span>
                                  <span className="info-item-value">{eDriverInfo?.valid_till ?? "N/A"}</span>
                                </div>
                                <div className="driver-info-item" style={{ alignItems: "center", display: "flex" }}>
                                  <span className="info-item-label">Status :</span>
                                  <span
                                    className="driver-status-value"
                                    style={{
                                      color: validateExpiryStatus(eDriverInfo?.valid_till).color,
                                    }}
                                  >
                                    {validateExpiryStatus(eDriverInfo?.valid_till).status}
                                  </span>
                                </div>
                              </div>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.license_msg}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )}

                      {isFieldEnabled("Proof") && (
                        <Col sm={12} lg={12}>
                          <div className="dotted-line "></div>
                        </Col>
                      )}
                      {isFieldEnabled("Proof attachment") && (
                        <div className="card-title">
                          Upload proof image
                          {isFieldMandatory("Profile Photo") && <span style={{ color: "#FF4444" }}>*</span>}
                        </div>
                      )}
                      <Row>
                        {isFieldEnabled("Proof attachment") && (
                          <Col sm={12} lg={6} className="mt-3">
                            <input
                              ref={licenseFileInputRef}
                              type="file"
                              accept=".jpg, .jpeg, .png"
                              onChange={handleLicenseFileChange}
                              style={{ display: "none" }} // Hide the actual file input
                            />
                            <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                              {/* {urlImageList.map((urlImage, index) => (
                            <div key={'url-image-'+index} className="mt-3" style={{position: "relative",}}> 
                            <img src={urlImage!=null && urlImage!==''?urlImage.image: ""} alt="license image" style={{ width: '72px', height: '72px', borderRadius:'14px' }} />
                            <div
        style={{
          position: "absolute",
          top: "1px",
          right: "1px", 
        }}
      >
        <div style={{ display:'flex',justifyContent:"start", alignItems:"center",}}>
         <SlotCloseIcon style={{cursor: "pointer",}} onClick={()=>{
        const tempRemoved=[...removedImageList];
        tempRemoved.push(urlImage.id)
         removedImageList(tempRemoved);
          const tempURLImageList=[...urlImageList];
          tempURLImageList.splice(index,1);
         
          setUrlImageList(tempURLImageList);         
          }}/>
        </div>
      </div> 
                          </div>
                          ))} */}
                              {selectedLicenseImageList.map((baseImage, index) => (
                                <div key={"base-image-" + index} className="mt-3" style={{ position: "relative" }}>
                                  <img
                                    src={baseImage != null && baseImage !== "" ? baseImage : ""}
                                    alt="complaint"
                                    style={{
                                      width: "72px",
                                      height: "72px",
                                      borderRadius: "14px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "1px",
                                      right: "1px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                      }}
                                    >
                                      <SlotCloseIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const tempImageList = [...selectedLicenseImageList];
                                          tempImageList.splice(index, 1);
                                          setSelectedLicenseImageList(tempImageList);
                                          const tempBase64FileList = [...base64FileLicenseList];
                                          tempBase64FileList.splice(index, 1);
                                          setBase64FileLicenseList(tempBase64FileList);
                                          /* setSelectedFile(null);setSelectedImage(null); */
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {renderProofCard({
                              targetKey: "license",
                              title: "Upload driving license image",
                              mandatoryField: "Proof attachment",
                              onUploadClick: handleLicenseFileClick,
                              imageList: selectedLicenseImageList,
                              setImageList: setSelectedLicenseImageList,
                              base64List: base64FileLicenseList,
                              setBase64List: setBase64FileLicenseList,
                            })}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.license_attachment}
                            </span>
                          </Col>
                        )}
                        {isFieldEnabled("Proof attachment") && (
                          <Col sm={12} lg={6} className="mt-3">
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept=".jpg, .jpeg, .png"
                              onChange={handleFileChange}
                              style={{ display: "none" }} // Hide the actual file input
                            />
                            <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                              {urlImageList.map((urlImage, index) => (
                                <div key={"url-image-" + index} className="mt-3" style={{ position: "relative" }}>
                                  <img
                                    src={urlImage != null && urlImage !== "" ? urlImage.image : ""}
                                    alt="complaint"
                                    style={{
                                      width: "72px",
                                      height: "72px",
                                      borderRadius: "14px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "1px",
                                      right: "1px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                      }}
                                    >
                                      <SlotCloseIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const tempRemoved = [...removedImageList];
                                          tempRemoved.push(urlImage.id);
                                          removedImageList(tempRemoved);
                                          const tempURLImageList = [...urlImageList];
                                          tempURLImageList.splice(index, 1);

                                          setUrlImageList(tempURLImageList);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {selectedImageList.map((baseImage, index) => (
                                <div key={"base-image-" + index} className="mt-3" style={{ position: "relative" }}>
                                  <img
                                    src={baseImage != null && baseImage !== "" ? baseImage : ""}
                                    alt="complaint"
                                    style={{
                                      width: "72px",
                                      height: "72px",
                                      borderRadius: "14px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "1px",
                                      right: "1px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                      }}
                                    >
                                      <SlotCloseIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const tempImageList = [...selectedImageList];
                                          tempImageList.splice(index, 1);
                                          setSelectedImageList(tempImageList);
                                          const tempBase64FileList = [...base64FileList];
                                          tempBase64FileList.splice(index, 1);
                                          setBase64FileList(tempBase64FileList);
                                          /* setSelectedFile(null);setSelectedImage(null); */
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {renderProofCard({
                              targetKey: "invoice",
                              title: "Upload bill or invoice image",
                              mandatoryField: "Invoice attachment",
                              onUploadClick: handleFileClick,
                              imageList: selectedImageList,
                              setImageList: setSelectedImageList,
                              base64List: base64FileList,
                              setBase64List: setBase64FileList,
                            })}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.attachments}
                            </span>
                          </Col>
                        )}
                      </Row>
                    </Row>
                  </div>
                )}

                <div className="card-view mt-3">
                  <div className="style-justify-start" style={{ gap: "8px" }}>
                    <div
                      onClick={() => {
                        setSelectedTab("Items");
                      }}
                      className={`tab-view style-justify-center ${selectedTab === "Items" ? "selected-tab" : ""}`}
                    >
                      Items
                    </div>
                    {isGuestEnable && (
                      <div
                        onClick={() => {
                          setSelectedTab("Guests");
                        }}
                        className={`tab-view style-justify-center ${selectedTab === "Guests" ? "selected-tab" : ""}`}
                      >
                        Guests
                      </div>
                    )}
                  </div>
                  {selectedTab === "Items" && itemList.length > 0 && (
                    <Col sm={12} lg={12} className="mt-3">
                      <div className="item-list-header" style={{ flex: "12" }}>
                        <span className="item-list-header-txt style-justify-start" style={{ flex: "4" }}>
                          <ItemNameIcon style={{ marginRight: "8px" }} />
                          Item Name
                        </span>
                        <span className="item-list-header-txt style-justify-start" style={{ flex: "3" }}>
                          <QuantityIcon style={{ marginRight: "8px" }} />
                          Quantity
                        </span>
                        <span className="item-list-header-txt style-justify-start" style={{ flex: "5" }}>
                          <DescriptionIcon style={{ marginRight: "8px" }} />
                          Description
                        </span>
                      </div>
                      <div>
                        {itemList.map((item, index) => (
                          <div key={"item-list" + index}>
                            <div className="item-list-row" style={{ flex: "12" }}>
                              <span className="item-list-row-txt" style={{ flex: "4" }}>
                                {item.item_name}
                              </span>
                              <span className="item-list-row-txt" style={{ flex: "3" }}>
                                {item.quantity}
                              </span>
                              <div className="item-list-row-txt" style={{ flex: "5", position: "relative" }}>
                                <span>{item.description}</span>
                                <div
                                  style={{
                                    position: "absolute",
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                  }}
                                >
                                  <div style={{ position: "relative" }}>
                                    <MoreIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setAlertItemIndex(index === alertItemIndex ? null : index);
                                      }}
                                    />
                                    {alertItemIndex === index && (
                                      <div
                                        ref={alertRef}
                                        style={{
                                          position: "absolute",
                                          top: "40px",
                                          left: "50%",
                                          transform: "translateX(-50%)",
                                          backgroundColor: "#ffffff",
                                          color: "#1E1E1E",
                                          padding: "16px",
                                          borderRadius: "16px",
                                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                          zIndex: 1,
                                          alignItems: "end",
                                        }}
                                      >
                                        <div
                                          onClick={() => {
                                            setItemData({
                                              item: item,
                                              index: index,
                                            });
                                            setAddItemModal(true);
                                            setAlertItemIndex(null);
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            width: "150px",
                                            height: "36px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#1E1E1E",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "start",
                                          }}
                                        >
                                          Edit
                                        </div>
                                        <div
                                          onClick={() => {
                                            const tempItems = [...itemList];
                                            tempItems.splice(index, 1);
                                            setItemList(tempItems);
                                            setAlertItemIndex(null);
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            width: "150px",
                                            height: "36px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#1E1E1E",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "start",
                                          }}
                                        >
                                          Delete
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="mt-2 style-justify-start">
                        <div
                          className="add-item-btn style-justify-center"
                          onClick={() => {
                            setAlertItemIndex(null);
                            setAddItemModal(true);
                          }}
                        >
                          <AddItem />
                          <div>Add item</div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {selectedTab === "Items" && itemList.length === 0 && (
                    <Col sm={12} lg={12} className="mt-3">
                      <div className="grid-view">
                        <div>
                          <ItemImg />
                        </div>
                        <div className="item-add-title mt-2">Visitor has items? Add them here</div>
                        <div>
                          <div
                            className="proof-btn mt-2 style-justify-center"
                            onClick={() => {
                              setAddItemModal(true);
                            }}
                          >
                            <AddItem />
                            <div className="proof-btn-txt add-item">Add item</div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}

                  {selectedTab === "Guests" && guestList.length === 0 && (
                    <Col sm={12} lg={12} className="mt-3">
                      <div className="grid-view">
                        <div>
                          <GuestImg />
                        </div>
                        <div className="item-add-title mt-2">Visitor has guests? Add them here</div>
                        <div>
                          <div
                            className="proof-btn mt-2 style-justify-center"
                            onClick={() => {
                              setAddGuestModal(true);
                            }}
                          >
                            <AddItem />
                            <div className="proof-btn-txt add-item">Add guest</div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                  {selectedTab === "Guests" && guestList.length > 0 && (
                    <Col>
                      <div>
                        {guestList.map((item, index) => (
                          <div className="mt-2" style={{ position: "relative" }}>
                            <div className="guest-item style-justify-start" style={{ flex: 15 }}>
                              <div style={{ flex: "2" }}>
                                <img className="guest-image-list" src={item["image"] != null && item["image"] !== "" ? item["image"] : ProfileImage} alt="guest" />
                              </div>
                              <div style={{ flex: "4", paddingLeft: "4px" }}>
                                <div className="guest-name">{item.name ?? ""}</div>
                                <div className="style-justify-start guest-phone">
                                  <PhoneIcon />
                                  <span style={{ paddingLeft: "8px" }}>{item.mobile_no ?? ""}</span>
                                </div>
                                <div className="guest-name">
                                  <span className="guest-age-title">Age :</span>
                                  <span className="guest-age-value">{item.age ?? ""}</span>
                                </div>
                              </div>
                              <div
                                style={{
                                  height: "37px",
                                  borderRight: "1.5px solid #E5E5E5",
                                }}
                              ></div>
                              <div style={{ flex: "3", paddingLeft: "8px" }}>
                                <div className="relation-type">Relation Type</div>
                                <div className="relation-type-value mt-1">{item.type ?? ""}</div>
                              </div>
                              <div style={{ flex: "5" }}>
                                <div className="relation-type">Proof</div>
                                <div className="style-justify-between guest-phone mt-1">
                                  <div className="relation-type-value">{item.proof_name ?? ""}</div>
                                  <div className="dot"></div>
                                  <div className="style-justify-center proof-type">
                                    <div className="px-2">{item.proof_value ?? ""}</div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                              }}
                            >
                              <div style={{ position: "relative" }}>
                                <MoreIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setAlertItemIndex(index === alertItemIndex ? null : index);
                                  }}
                                />
                                {alertItemIndex === index && (
                                  <div
                                    ref={alertRef}
                                    style={{
                                      position: "absolute",
                                      top: "40px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      backgroundColor: "#ffffff",
                                      color: "#1E1E1E",
                                      padding: "16px",
                                      borderRadius: "16px",
                                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                      zIndex: 1,
                                      alignItems: "end",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        setItemData({
                                          guest: item,
                                          index: index,
                                        });
                                        setAddGuestModal(true);
                                        setAlertItemIndex(null);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        width: "150px",
                                        height: "36px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#1E1E1E",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "start",
                                      }}
                                    >
                                      Edit
                                    </div>
                                    <div
                                      onClick={() => {
                                        const tempGuest = [...guestList];
                                        tempGuest.splice(index, 1);
                                        setGuestList(tempGuest);
                                        setAlertItemIndex(null);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        width: "150px",
                                        height: "36px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#1E1E1E",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "start",
                                      }}
                                    >
                                      Delete
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="mt-2 style-justify-start">
                        <div
                          className="proof-btn mt-2 style-justify-center"
                          onClick={() => {
                            setAlertItemIndex(null);
                            setAddGuestModal(true);
                          }}
                        >
                          <AddItem />
                          <div className="proof-btn-txt add-item">Add guest</div>
                        </div>
                      </div>
                    </Col>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <ManualVehicleModal
        show={showManualVehicleModal}
        onHide={() => setShowManualVehicleModal(false)}
        vehicleNo={vehicleNumber}
        onSuccess={(data) => {
          setEVehicleInfo(data);
          setShowManualVehicleModal(false);
          setIsVehicleApiUnavailable(false);
        }}
      />
      <ManualDriverModal
        show={showManualDriverModal}
        onHide={() => setShowManualDriverModal(false)}
        dlNumber={proofNumber}
        onSubmit={(data) => {
          setEDriverInfo(data);
          setShowManualDriverModal(false);
          setIsDriverApiUnavailable(false);
        }}
      />
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};
